<template>
    <Pagebody class="singadd_wrapper" :loading='loading'>
        <div style="padding:10px;background: rgb(247, 248, 250);">
            <AddBuy ref="addbuy" :data="addBuyData"/>
            <div class="price_ctrl_wrapper">
                <div class="price" v-html='mainPrice'></div>
                <div class="control">
                    数量
                    <div class="arrow disabled">
                        <span class="buynum">{{quant}}</span>
                    </div>
                    <NormalButton class="buy" :theme='"red"' ref='buy' @click='buynow'>立即购买
                    </NormalButton>

                </div>
            </div>
        </div>
    </Pagebody>
</template>

<script>
import wh from '../../assets/js/wh';
import AddBuy from '../../components/AddBuy.vue';
    export default {
        components: {AddBuy},
        inject: ['initOrder', 'popOverShow', 'orderShow', 'appOverFlow'],
        provide () {
            const self = this
            return {
                changeMainPrice (val) {
                    self.price = val
                },
                getPwdAddress () {
                    return self.pwdAddress
                },
                globalTabType () {
                    return 'add'
                },
                currentPage () {
                    return 'add'
                },
                changeAuthPrice (val) {
                    self.annexation = val
                },
                addValidCross () {

                },
                orderByMonth () {

                },
                setHistoryIsPoping () {

                }
            }
        },
        data: () => ({
            loading: false,
            quant: 1,
            addBuyData: [],
            price: 0,
            annexation: 0,
            unit: '',
            pwdAddress: '',
            sourceData: null
        }),
        methods: {
            async buynow(finish,load) {
                
                if (!this.$store.state.addbuy.fetchData) {
                        finish()
                        this.$market.alert({
                            content: '请先验证加购账号。'
                        })
                        return
                    }
                    if (this.$refs.addbuy.selectIds == '') {
                        finish()
                        this.$market.alert({
                            content: '请到下方选择加购授权内容。'
                        })
                        return
                    }
                    var url = this.$refs.addbuy.hasOut ? '/api/Order/CMEIndex' : '/api/Order/NeiPan'
                    var ismajor = this.$refs.addbuy.hasMajor
                    var isjg = this.$refs.addbuy.hasOgz
                    var ids = this.$refs.addbuy.selectIds
                    var data = {
                        productId: parseInt(this.$store.state.addbuy.fetchData.data.productid), // 加购的产品号从接口中取，原parseInt(this.$route.params.id),
                        isDanAuthorization: false,
                        identityType: 3,
                        dzh: this.$store.state.addbuy.fetchData.data.bigacc,
                        xzh: this.$store.state.addbuy.fetchData.data.xzh,
                        subids: ids,
                        buynum: parseInt(this.quant),
                        userCode: this.$store.state.addbuy.fetchData.data.userCode,
                        ismajor: ismajor,
                        isjg: isjg,
                        userSdate: this.$store.state.addbuy.fetchData.data.stime,
                        userEdate: this.$store.state.addbuy.fetchData.data.time,
                        morderid: ''
                    }
                    this.$store.commit('addbuy/setInterface', {
                        url,
                        data
                    })
                    this.$axios({
                        url: url,
                        method: "post",
                        data: data,
                    })
                    .then(res => {
                        finish()
                        if (!res.data.status) {
                            return this.$market.alert({
                                content: res.data.message
                            })
                        }
                        res.data.hasHistory = this.$refs.addbuy.hasHistoryData
                        if (res.data.hasHistory) {
                            res.data.isCme = true
                        }
                        this.$store.commit('setOrderInfo', res)
                        
                        this.initOrder();
                        this.popOverShow(true);
                        this.orderShow(true);
                        this.appOverFlow('hidden');
                    }).catch(e => {
                        finish()
                    })
            },
            init (res) {
                this.sourceData = res
                console.log(res)
                this.unit = res.data.unit
                this.pwdAddress = res.data.pwdAddress

                let configure = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype == -1).map(v => ({
                    name: v.productName,
                    price: v.price,
                    monthprice: v.monthprice,
                    id: v.id,
                    link: v.link,
                    disable: true,
                    bought: false,
                    isTaoli: v.isTaoli
                })) : []
                let authorization = res.data.sublist ? res.data.sublist.filter(v=>v.grouptype != -1) : []

                let addInnerAuth = authorization.filter(v => v.isout == 0 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addOuterAuth = authorization.filter(v => v.isout == 1 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addHistoryData = authorization.filter(v => v.grouptype == 7 || v.grouptype == 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let add_require = []
                if (addInnerAuth.length>0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '国内五档数据等',
                        sublist: addInnerAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (addOuterAuth.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '境外实时数据',
                        sublist: addOuterAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (addHistoryData.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '历史数据API',
                        link: 'https://www.wenhua.com.cn/guide/lssj.htm',
                        sublist: addHistoryData, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }

                if (configure.length > 2) {
                    this.addBuyData = [...add_require,{type: 'line'},...configure]
                } else {
                    this.addBuyData = [...configure, ...add_require]
                }

                if (this.$route.params.id == '1' || this.$route.params.id == '124') {//如果是wh8或者wh9的产品，只能暂时固定写死（柏慧提的需求），把多账号数据调到境外数据后面
                    let target_index = this.addBuyData.findIndex(v => v.name == '多账号下单模块'),
                        plunge_index = this.addBuyData.findIndex(v => v.name == '境外实时数据'),
                        target = this.addBuyData[target_index]
                    
                    this.addBuyData.splice(target_index, 1)
                    this.addBuyData.splice(plunge_index, 0, target)
                }
                console.log(this.addBuyData)
            }
        },
        computed: {
            mainPrice() {
                var quant = this.quant,
                    price = this.price,
                    annexation = this.annexation
                // if (this.orderLimit == -1 && this.canOrderByMonth) {
                //     return `<span class="m">￥</span><span class="num">--</span>&nbsp;元`
                // }
                if (this.tabType == 'add') { //加购只有授权价格
                    return `<span class="m">￥</span><span class="num">${quant*annexation}</span>&nbsp;元/${this.unit}`
                }
                if (!annexation) {
                    return `<span class="m">￥</span><span class="num">${quant*price}</span>&nbsp;元/${this.unit}`
                }
                return `<span class="m">￥</span><span class="num">${quant*price}</span>&nbsp;元<span
                        class="num">&nbsp;&nbsp;+${quant*annexation}&nbsp;</span>元/${this.unit}`
            },
        },
        created () {
            this.loading = true
            this.$axios({
                url: "/api/Product/Detail?id="+this.$route.params.id,
                method: "get",
                useCache: true
            })
            .then((res,isCache) => {
                this.loading = false
                if (res.data.status) {
                    this.init(res.data)
                    
                } else {
                    this.$market.alert({content: res.data.message,confirmCall () {
                        self.$router.push('/')
                    }})
                }
                
            }).catch(e=>{
                console.log(e)
                this.$market.alert({content: '服务器错误，请稍后再试。'})
            })
        }
    }
</script>

<style scoped>
    .singadd_wrapper {
        width: 1000px;
        margin-left: 200px !important;
    }
    .price_ctrl_wrapper {
        overflow: hidden;
        background: rgb(247, 248, 250);
        padding-right: 10px;
        padding-bottom: 20px;
    }

    .price {
        height: 30px;
        color: rgb(135, 135, 135);
        font-size: 14px;
        padding-left: 8px;
        box-sizing: border-box;
        float: left;
    }
    .control {
        height: 30px;
        font-size: 12px;
        float: right;
    }
    .arrow {
        display: inline-block;
        vertical-align: middle;
        height: 27px;
        overflow: hidden;
        border: 1px solid rgb(207, 211, 213);
        background: white;
    }
    .buy {
        width: 78px;
        height: 27px;
        text-align: center;
        background: rgb(230, 0, 0);
        color: white;
        font-size: 14px;
        vertical-align: middle;
        margin-left: 15px;
        display: inline-block;
    }
    .buynum {
        width: auto;
        padding: 0 5px;
        height: 27px;
        line-height: 26px;
        vertical-align: middle;
        text-align: center;
        outline: 0;
        float: left;
        border: 0;
        color: rgb(133, 133, 133);
        font-size: 14px;
    }
    .arrow.disabled {
        border: 1px solid transparent;
        background: transparent;
    }
</style>